export default __webpack_public_path__ + "static/media/logo.4ba2ec89.svg";